import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import {
  SmartToy as BotIcon,
  TrendingUp as TrendingUpIcon,
  Speed as SpeedIcon,
  CheckCircle as ActiveIcon,
} from '@mui/icons-material';

const BotStatistics: React.FC = () => {
  const stats = [
    {
      title: 'Total Bots',
      value: '1,234',
      change: '+12%',
      icon: <BotIcon />,
      color: '#2563eb',
    },
    {
      title: 'Active Bots',
      value: '987',
      change: '+8%',
      icon: <ActiveIcon />,
      color: '#10b981',
    },
    {
      title: 'Avg Performance',
      value: '23.5%',
      change: '+5.2%',
      icon: <TrendingUpIcon />,
      color: '#f59e0b',
    },
    {
      title: 'Avg Speed',
      value: '1.2s',
      change: '-0.3s',
      icon: <SpeedIcon />,
      color: '#06b6d4',
    },
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
        Bot Statistics
      </Typography>

      <Grid container spacing={3}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: `${stat.color}15`,
                      color: stat.color,
                      mr: 2,
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      {stat.title}
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                      {stat.value}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: stat.change.startsWith('+') ? 'success.main' : 'error.main',
                    fontWeight: 600,
                  }}
                >
                  {stat.change} from last month
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            Bot Usage Metrics
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Detailed bot statistics and performance metrics will be displayed here.
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};

export default BotStatistics;

